export const teamMap: any = {
    'car': 12,
    'cbj': 29,
    'njd': 1,
    'nyi': 2,
    'nyr': 3,
    'phi': 4,
    'pit': 5,
    'wsh': 15,
    'bos': 6,
    'buf': 7,
    'det': 17,
    'fla': 13,
    'mon': 8,
    'mtl': 8,
    'ott': 9,
    'tbl': 14,
    'tor': 10,
    'chi': 16,
    'col': 21,
    'dal': 25,
    'min': 30,
    'nsh': 18,
    'stl': 19,
    'wpg': 52,
    'ana': 24,
    'phx': 27,
    'ari': 53,
    'cgy': 20,
    'edm': 22,
    'lak': 26,
    'sjs': 28,
    'van': 23,
    'atl': 11,
    'mns': 31,
    'que': 32,
    'win': 33,
    'hfd': 34,
    'clr': 35,
    'sen': 36,
    'ham': 37,
    'pir': 38,
    'qua': 39,
    'dcg': 40,
    'mwn': 41,
    'qbd': 42,
    'mmr': 43,
    'nya': 44,
    'sle': 45,
    'oak': 46,
    'afm': 47,
    'kcs': 48,
    'cle': 49,
    'dfl': 50,
    'brk': 51,
    'vgk': 54,
    'cgs': 56,
    'tan': 57,
    'tsp': 58,
    'sea': 55,
    'uta': 66, 
};